var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUpFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-BadgeCaretUp",
    clipPath: "url(#clip0_204_30001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.4137 9.36997C10.618 9.55572 10.9342 9.54067 11.12 9.33634C11.3057 9.13201 11.2907 8.81578 11.0863 8.63003L8.33634 6.13003C8.14563 5.95666 7.85438 5.95666 7.66367 6.13003L4.91367 8.63003C4.70934 8.81579 4.69428 9.13201 4.88003 9.33634C5.06579 9.54067 5.38201 9.55573 5.58634 9.36997L8 7.17573L10.4137 9.36997Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_30001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUpFilled);
export default __webpack_public_path__ + "static/media/caret-up-filled.8bb8cd99d3bd5aad1b746af77985c13f.svg";
export { ForwardRef as ReactComponent };